import * as React from "react";

import connectToList from "../../store/list";

import GenControlsBar from "../Gen/ControlsBar";
import GenMore from "../Gen/More";
import GenSearchBox from "../Gen/SearchBox";

import CategorySummary from "./Summary";

interface CategoryListProps {
  categories: ConnectedList<CategorySnakeModel>;
  currentUser: UserSnakeModel,
  currentRoleDefinition: RoleDefinitionSnakeModel
}

function CategoryList(props: CategoryListProps) {
  const {
    categories,
    currentUser,
    currentRoleDefinition,
  } = props;

  React.useEffect(() => {
    categories.mountList("/categories");
  }, []);

  return (
    <div>
      <GenControlsBar>
        <GenSearchBox
          {...categories}
        />
      </GenControlsBar>
      {categories.listData?.map((category) => (
        <CategorySummary
          key={category.id}
          {...category}
          currentUser={currentUser}
          currentRoleDefinition={currentRoleDefinition}
          reloadCategories={() => categories.reloadList()}
        />
      ))}
      <GenMore
        {...categories}
        shouldInfiniteScroll
      />
    </div>
  );
}

export default connectToList(CategoryList, ["categories"]);
